<template>
	<ul class="UnorderedList" :class="ulClasses">
		<!-- @slot This holds the unordered list-->
		<slot />
	</ul>
</template>

<script>
import CloUnorderedListItem from './CloUnorderedListItem';
export default {
	props: {
		/**
		 * Class group of the component 
		 * 
		*/
		classes: {
			type: String,
			default: '',
		},
		/**
		 * Flatten the list or not 
		 * */
		flat: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		ulClasses() {
			return [this.classes, this.flat ? 'UnorderedList--flat' : ''].join(
				' '
			);
		},
	},
};
</script>

<style lang="scss">
.UnorderedList--flat {
	list-style: none;
	margin-left: 0;
	[dir='rtl'] & {
		margin-right: 0;
	}
}

.UnorderedList--submenu {
	list-style: none;
	margin-left: 0;
	[dir='rtl'] & {
		margin-right: 0;
	}
	margin-top: 2rem;
	font-weight: bold;
	line-height: 1.2;
	.Icon {
		@include icon-sm;
		padding-bottom: 3px;
		color: $color-link;
	}
	.UnorderedList-inactive {
		display: inline-block;
		width: 0.6rem;
	}
	ul {
		font-weight: normal;
		list-style: none;
		margin-left: 1.25rem;
		[dir='rtl'] & {
			margin-right: 1.25rem;
			margin-left: 0;
		}
		li {
			margin: 0.1rem 0;
		}
	}
	li {
		margin: 0.5rem 0;
		padding-left: 0.75rem;
		[dir='rtl'] & {
			padding-left: 0;
			padding-right: 0.75rem;
		}
		text-indent: -0.75rem;
	}
}

.UnorderedList--flex {
	display: flex;
	flex-wrap: wrap;
	@include text(3);
	margin: 0;
	li {
		@include inline-md;
		.Icon {
			@include inline-xs;
			@include icon-sm;
		}
	}
	@include breakpoint(medium) {
		justify-content: flex-end;
		li {
			margin: 0 0 0 $space-md;
			[dir='rtl'] & {
				margin: 0 $space-md 0 0;
			}
		}
	}
}

/* Side nav variant - simple list used in eBird */
.UnorderedList--sideNav {
	list-style: none;
	margin-left: 0;
	[dir='rtl'] & {
		margin-right: 0;
	}
	margin-bottom: 0;
	li {
		@include stack-sm;
		line-height: 1.4;
		&:last-child {
			margin-bottom: 0;
		}
	}
}
</style>